import starIcon from "../../assets/images/star-icon.svg";

export default function MovingText() {
  return (
    <div className="w-full h-[120px] md:h-[230px] bg-transparent overflow-hidden relative">
      <div className="flex gap-8 md:gap-16 absolute top-1/2 transform -translate-y-1/2 whitespace-nowrap animate-scroll">
        <p className="flex gap-8 md:gap-16 items-center text-[#E7E7E7] font-barlow font-semibold text-[48px] md:text-[96px] leading-none capitalize tracking-wide">
          <span>Lean Six Sigma Master Black Belt</span>
          <img src={starIcon} alt="star" className="h-8 w-8 md:w-auto md:h-auto" />
          <span>MBA</span>
          <img src={starIcon} alt="star" className="h-8 w-8 md:w-auto md:h-auto" />
          <span>Operations Management Specialist</span>
          <img src={starIcon} alt="star" className="h-8 w-8 md:w-auto md:h-auto" />
        </p>
        <p className="flex gap-8 md:gap-16 items-center text-[#E7E7E7] font-barlow font-semibold text-[48px]
        md:text-[96px] leading-none capitalize tracking-wide ml-24 md:ml-48">
          <span>Lean Six Sigma Master Black Belt</span>
          <img src={starIcon} alt="star" className="h-8 w-8 md:w-auto md:h-auto" />
          <span>MBA</span>
          <img src={starIcon} alt="star" className="h-8 w-8 md:w-auto md:h-auto" />
          <span>Operations Management Specialist</span>
        </p>
      </div>
    </div>
  );
}
